<template>
    <div id="userSection">
        <card>
            <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection" @keyup.enter.native="doSearch()">
                <FormItem prop="keyword">
                    <Input type="text" v-model="searchForm.keyword" placeholder="账号"  ></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="doSearch"  size="small">搜索</Button>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="add" size="small">新增</Button>
                </FormItem>
            </Form>
            <!--<Row id="operation">-->
                <!--<Button type="primary" @click="add" size="small">新增</Button>-->
            <!--</Row>-->
            <Table :columns="columns" :data="data" :loading="dataLoading"></Table>
            <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total
                  @on-change="changePage" :page-size="20" ></Page>
        </card>
        <user-form ref="UserForm" v-on:close="onCloseForm"></user-form>
    </div>
</template>
<script>
    import UserForm from './form.vue';

    export default {
        name: 'setting_user',
        data () {
            return {
                searchForm:{
                    keyword:''
                },
                columns: [
                    {
                        title: '账号',
                        key: 'account'
                    },
                    {
                        title: '姓名',
                        key: 'name'
                    },
                    {
                        title: '校区',
                        key: 'zonename'
                    },
                    {
                        title: '电话',
                        key: 'mobile'
                    },
                    {
                        title: '状态',
                        key: 'state',
                        render: (h, params) => {
                            if (params.row.state == 1){
                                return h('Tag',
                                    {
                                        props: {
                                            color: 'primary'
                                        },
                                    },'正常');
                            }else{
                                return h('Tag',
                                    {
                                        props: {
                                            color: 'error'
                                        },
                                    },'禁用');
                            }

                        }
                    },
                    {
                        title: '操作',
                        width: 150,
                        render: (h, params) => {
                            let self = this;

                            let opArray = [];

                            opArray.push(h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.UserForm.showWin(params.row.id);
                                    }
                                }
                            }, '修改'));
                            if (params.row.account != 'admin'){
                                opArray.push(h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            self.$Modal.confirm({
                                                title: '提示',
                                                content: '是否确定删除？',
                                                onOk: () => {
                                                    self.$api.user.del({id:params.row.id}).then(resp => {
                                                        if (resp.state == 'ok'){
                                                            self.$Message.info('删除成功');
                                                            self.getList();
                                                        }else{
                                                            this.saving = false;
                                                            self.$Message.error(resp.msg);
                                                        }
                                                    });
                                                },
                                                onCancel: () => {

                                                }
                                            });
                                        }
                                    }
                                }, '删除'));
                            }

                            return h('div',opArray);

                        }
                    }
                ],
                data: [],
                dataLoading: false,
                ruleInline: {

                },
                totalPage:0,
                pageTotalNum:0,
                pageCurrent:1
            }
        },
        computed: {
            showPager : function(){
                return this.totalPage > 1
            }
        },
        methods: {
            getList(){
                this.dataLoading = true;
                let param = {
                    p:this.pageCurrent
                }
                if (this.searchForm.keyword){
                    param.keyword = this.searchForm.keyword;
                }
                this.$api.user.getList(param).then(resp => {
                    this.data = resp.data.list;
                    this.pageTotalNum = resp.data.totalRow;
                    this.totalPage = resp.data.totalPage;
                    this.pageCurrent = resp.data.pageNumber;
                    this.dataLoading = false;
                });
            },
            add(){
                this.$refs.UserForm.showWin();
            },
            changePage (page) {
                this.pageCurrent = page;
                this.getList();
            },
            doSearch(){
                this.pageCurrent = 1;
                this.getList();
            },
            onCloseForm(){
                this.getList();
            }
        },
        mounted: function () {
            this.getList();
        },
        components: {
            UserForm
        }
    }
</script>
